import permission from './permission' // 权限
import loading from './loading/index' // loading
import empty from './empty/index' // 空状态

export default (app: { directive: (arg0: string, arg1: any) => void }) => {
  app.directive('permission', permission)
  app.directive('load', loading)
  app.directive('empty', empty)
}
